import classNames from 'classnames';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { showLeftPane } from '../../../ducks/panes';
import { RootState } from '../../../ducks/store';
import { Panes } from '../../../utils/constants';
import Pane from '../Pane/Pane';
import TeamsTree from '../Pane/TeamsTree';

import './NavRail.scss';

const Paths = {
  Dashboard: '/',
  Courses: '/admin/courses',
  Teams: '/admin/teams',
  Users: '/admin/users',
  GeneralReport: '/admin/reports/general',
  CLEReport: '/admin/reports/cle',
};

const NavRail = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const pathname = location?.pathname;
  const { showLeft, leftType } = useSelector((state: RootState) => {
    const { panes } = state;
    const { showLeft, leftType } = panes;
    return {
      showLeft,
      leftType,
    };
  });

  return (
    <>
      <div className="NavRail">
        <div
          className="NavRail-item bordered"
          onClick={() => dispatch(showLeftPane(!showLeft, leftType))}
        >
          <div className="NavRail-item-contents">
            <span className="material-icons">{showLeft ? 'first_page' : 'menu'}</span>
            <div>{showLeft ? 'Hide' : 'Menu'}</div>
          </div>
        </div>
        <div
          className={classNames('NavRail-item', 'bordered', {
            active: pathname === Paths.Dashboard,
          })}
          onClick={() => navigate(Paths.Dashboard)}
        >
          <div className="NavRail-item-contents">
            <span className="material-icons">grid_view</span>
            <div>Home</div>
          </div>
        </div>
        <div
          className={classNames('NavRail-item', {
            active: pathname === Paths.Courses,
          })}
          onClick={() => navigate(Paths.Courses)}
        >
          <div className="NavRail-item-contents">
            <span className="material-icons-outlined">school</span>
            <div>Courses</div>
          </div>
        </div>
        <div
          className={classNames('NavRail-item', {
            active: pathname === Paths.GeneralReport,
          })}
          onClick={() => navigate(Paths.GeneralReport)}
        >
          <div className="NavRail-item-contents">
            <span className="material-icons-outlined">assessment</span>
            <div>Reports</div>
          </div>
        </div>
        <div
          className={classNames('NavRail-item', {
            active: pathname === Paths.Teams,
          })}
          onClick={() => {
            dispatch(showLeftPane(true, Panes.Teams));
          }}
        >
          <div className="NavRail-item-contents">
            <span className="material-icons-outlined">group</span>
            <div>Teams</div>
          </div>
        </div>
        <div
          className={classNames('NavRail-item', {
            active: pathname === Paths.Users,
          })}
          onClick={() => navigate(Paths.Users)}
        >
          <div className="NavRail-item-contents">
            <span className="material-icons">person_outline</span>
            <div>Users</div>
          </div>
        </div>
      </div>
      <Pane small left>
        {leftType === Panes.Teams && <TeamsTree />}
      </Pane>
    </>
  );
};

export default NavRail;
